import { Spin, Table } from 'antd';

import type { ModelProduct } from '@app/api/Products';
import { useWindowSize } from '@app/hooks';
import { PF } from '@app/pages/Warehouses/ProductDirectory/data';
import type { ProductDirectoryTableType } from '@app/pages/Warehouses/ProductDirectory/types';
import { getRange } from '@app/pages/Warehouses/ProductDirectory/utils';

const TABLE = `${PF}_table`;

export const ProductDirectoryTable: ProductDirectoryTableType = ({
  columns,
  data,
  total,
  filters: { PageN, ItemsPerPage },
  onPaginate,
  onPageSizeChange,
  isPageLoading = false,
  isFetching = false,
}) => {
  const { isMobile } = useWindowSize();

  if (isPageLoading) {
    return (
      <div className={`${TABLE}_loading`}>
        <Spin spinning />
      </div>
    );
  }

  const { from, to } = getRange({ ItemsPerPage, Total: total, PageN });

  return (
    <div className={`${TABLE}_container`}>
      <div className={`${TABLE}_content`}>
        <Table<ModelProduct>
          columns={columns}
          dataSource={data}
          rowKey={({ Id }) => Id}
          pagination={
            total > 0
              ? {
                  responsive: true,
                  current: PageN,
                  total,
                  pageSize: ItemsPerPage,
                  showSizeChanger: true,
                  showLessItems: isMobile,
                  size: isMobile ? 'small' : 'default',
                  position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
                  onChange: onPaginate,
                  onShowSizeChange: (_, pageSize) => onPageSizeChange(pageSize),
                  showTotal: (itemsTotal) =>
                    isMobile
                      ? `Всего ${itemsTotal}`
                      : `Показаны результаты с ${from} по ${to} из ${itemsTotal}`,
                }
              : false
          }
          size={isMobile ? 'small' : 'middle'}
          rowClassName={({ IsDeleted }) => (IsDeleted ? 'deleted-row' : '')}
          loading={isFetching}
          scroll={{ x: 'max-content' }}
          className={`${TABLE}_grid`}
        />
      </div>
    </div>
  );
};
